import { Button } from '@/components/ui/button'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import { CheckCircle, Calendar, User, Car, Scissors, Loader2 } from 'lucide-react'

const formatBRL = (n: number) =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(n)

export function BookingCheckout({ flow }: { flow: any }) {
  const { 
    date, time, 
    nome, phone, plate, vehicleModel, 
    selectedServices, washer, 
    totalDuration, totalPrice,
    submit, submitting 
  } = flow

  return (
    <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-slate-100">Quase lá!</h2>
        <p className="text-slate-400 text-sm mt-1">Confirme os dados do seu agendamento</p>
      </div>

      <div className="bg-slate-800/50 border border-slate-700 rounded-xl p-5 space-y-4">
        
        <div className="flex items-start gap-3">
          <Calendar className="w-5 h-5 text-blue-400 mt-0.5" />
          <div>
            <p className="text-sm text-slate-400">Data e Horário</p>
            <p className="font-semibold text-slate-100 capitalize">
              {format(date, "EEEE, dd 'de' MMMM", { locale: ptBR })} às {time}
            </p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Car className="w-5 h-5 text-blue-400 mt-0.5" />
          <div>
            <p className="text-sm text-slate-400">Veículo</p>
            <p className="font-semibold text-slate-100">{vehicleModel} - {plate}</p>
            <p className="text-sm text-slate-400">{nome} ({phone})</p>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <Scissors className="w-5 h-5 text-blue-400 mt-0.5" />
          <div className="w-full">
            <p className="text-sm text-slate-400">Serviços ({totalDuration} min)</p>
            <ul className="mt-1 space-y-1">
              {selectedServices.map((s: any) => (
                <li key={s.id} className="flex justify-between text-slate-100 text-sm">
                  <span>{s.name}</span>
                  <span className="font-medium">{formatBRL(Number(s.price))}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="flex items-start gap-3">
          <User className="w-5 h-5 text-blue-400 mt-0.5" />
          <div>
            <p className="text-sm text-slate-400">Lavador</p>
            <p className="font-semibold text-slate-100">
              {washer ? washer.name : 'Qualquer profissional disponível'}
            </p>
          </div>
        </div>

        <div className="pt-4 border-t border-slate-700 mt-4 flex justify-between items-center">
          <p className="text-slate-400">Total a pagar</p>
          <p className="text-2xl font-bold text-slate-100">{formatBRL(totalPrice)}</p>
        </div>

      </div>

      <div className="flex gap-2">
        <Button variant="outline" className="w-1/3" onClick={() => flow.setStep(5)} disabled={submitting}>
          Voltar
        </Button>
        <Button className="w-2/3" onClick={submit} disabled={submitting}>
          {submitting ? (
            <>
              <Loader2 className="w-4 h-4 mr-2 animate-spin" />
              Agendando...
            </>
          ) : (
            <>
              <CheckCircle className="w-4 h-4 mr-2" />
              Confirmar Agendamento
            </>
          )}
        </Button>
      </div>
    </div>
  )
}
